import styled from 'styled-components';

export default styled.div`
  height: calc(100% - var(--top-bar-height));
  .app--figma-plugin & {
    height: 100%;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  position: relative;

  @media screen and (min-width: 600px) and (max-height: 750px) {
    height: calc(100% - 50px);
  }
`;



// WEBPACK FOOTER //
// ./src/components/Page.ts